module.exports = __webpack_public_path__ + "img/campaign-icon-dark.d19a1b67.svg";